import { DataSource, Layout, Panel, Switch, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlTest extends Layout {
    panelMcTest: Panel;
    sourceMcTest: DataSource;
    switchIsActive: Switch;
    tableMcTest: Table;
}
